var map = {
	"./AutocompleteItemTemplate-style.js": 673,
	"./ButtonsTemplate-style.js": 674,
	"./CheckboxTemplate-style.js": 675,
	"./CheckboxesGroupTemplate-style.js": 676,
	"./CollectionCreateTemplate-style.js": 677,
	"./CollectionMixin-style.js": 678,
	"./EditorTemplate-style.js": 679,
	"./FormTemplate-style.js": 680,
	"./ItemToStringTemplate-style.js": 681,
	"./List-style.js": 682,
	"./ListItemTemplate-style.js": 683,
	"./Mixed-style.js": 684,
	"./ModalTemplate-style.js": 685,
	"./RadioItemTemplate-style.js": 686
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 672;



/*****************
 ** WEBPACK FOOTER
 ** ./~/subschema/src/styles nonrecursive ^.*-style\.js$
 ** module id = 672
 ** module chunks = 0
 **/